import { render, staticRenderFns } from "./OptionPropertyPreferences.vue?vue&type=template&id=7353e9c4"
import script from "./OptionPropertyPreferences.vue?vue&type=script&lang=js"
export * from "./OptionPropertyPreferences.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports